<template>
    <div>
        <v-col cols="12">
            <h2 class="mt-4 mb-0">{{ t('acl::page.title.acl_entity_fields') }}</h2>

            <b-datatable
                ref="datatable"
                :columns="columns"
                :endpoint="listRoute"
                has-filters
                :list-title="t('default::grid.title.acl_entity_list')"
                :hidden-columns="hiddenColumns"
                :multi-sort="false"
                has-filter-selector
                item-key="id"
                labels-namespace="acl"
                entity-name="acl_entity_field"
            >
                <template #filters="{ filters }">
                    <v-col cols="4" class="pb-0">
                        <b-filter-input
                            v-model="filters.filters.search"
                            field="acl::acl_entity_field.search"
                        ></b-filter-input>
                    </v-col>

                    <v-col cols="4" class="pb-0">
                        <b-filter-select
                            v-model="filters.filters.type"
                            :items="filterTypes"
                            field="acl::acl_entity_field.type"
                            :clearable="filters.filters.type !== null"
                            item-text="label"
                            item-value="value"
                        >
                        </b-filter-select>
                    </v-col>

                    <v-col cols="4" class="pb-0">
                        <b-filter-select
                            v-model="filters.filters.system"
                            :items="filterItems"
                            field="acl::acl_entity_field.system"
                            :clearable="filters.filters.system !== null"
                            item-text="label"
                            item-value="value"
                        >
                        </b-filter-select>
                    </v-col>

                    <v-col cols="4" class="pb-0">
                        <b-filter-select
                            v-model="filters.filters.hidden"
                            :items="filterItems"
                            field="acl::acl_entity_field.hidden"
                            :clearable="filters.filters.hidden !== null"
                            item-text="label"
                            item-value="value"
                        >
                        </b-filter-select>
                    </v-col>

                    <v-col cols="4" class="pb-0">
                        <b-filter-select
                            v-model="filters.filters.visible"
                            :items="filterItems"
                            field="acl::acl_entity_field.visible"
                            :clearable="filters.filters.visible !== null"
                            item-text="label"
                            item-value="value"
                        >
                        </b-filter-select>
                    </v-col>

                    <v-col cols="4" class="pb-0">
                        <b-filter-select
                            v-model="filters.filters.audit_disabled"
                            :items="filterItems"
                            field="acl::acl_entity_field.audit_disabled"
                            :clearable="filters.filters.audit_disabled !== null"
                            item-text="label"
                            item-value="value"
                        >
                        </b-filter-select>
                    </v-col>
                </template>

                <template #[`item.visible`]="{ item }">
                    <div class="grid-status">
                        <span>
                            {{ item.visible ? t('default::label.yes') : t('default::label.no') }}
                        </span>
                    </div>
                </template>
                <template #[`item.audit_disabled`]="{ item }">
                    <div class="grid-status">
                        <span>
                            {{ item.audit_disabled ? t('default::label.yes') : t('default::label.no') }}
                        </span>
                    </div>
                </template>

                <template #[`item.system`]="{ item }">
                    <div class="grid-status">
                        <span>
                            {{ item.system ? t('default::label.yes') : t('default::label.no') }}
                        </span>
                    </div>
                </template>

                <template #[`item.hidden`]="{ item }">
                    <div class="grid-status">
                        <span>
                            {{ item.hidden ? t('default::label.yes') : t('default::label.no') }}
                        </span>
                    </div>
                </template>

                <template #[`item.type`]="{ item }">
                    {{ t('acl::field_type.' + item.type) }}
                </template>

                <template #[`item.actions`]="{ item }">
                    <b-grid-row-actions
                        :item="item"
                        labels-namespace="acl"
                        entity-name="entity_field"
                        edit-route="acl.entity-fields.get"
                        edit-api-route="api.v1.acl.entity-fields.update"
                        has-export-record-button
                        export-record-route="acl.entity-fields.export-record-as-pdf"
                    >
                    </b-grid-row-actions>
                </template>
            </b-datatable>
        </v-col>
    </div>
</template>

<script>
export default {
    props: {
        listRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            hiddenColumns: ['id'],
            filterItems: [
                { label: t('default::label.all'), value: '' },
                { label: t('default::labels.no'), value: 0 },
                { label: t('default::labels.yes'), value: 1 },
            ],
            filterTypes: [
                { label: t('default::label.all'), value: '' },
                { label: t('acl::field_type.field'), value: 'field' },
                { label: t('acl::field_type.association'), value: 'association' },
            ],
            columns: [
                {
                    value: 'id',
                    sortable: false,
                },
                {
                    value: 'tag',
                    sortable: true,
                    width: '150',
                },
                {
                    value: 'name',
                    sortable: true,
                    width: '150',
                },
                {
                    value: 'system_name',
                    sortable: true,
                    width: '350',
                },
                {
                    value: 'type',
                    sortable: true,
                    width: '150',
                },
                {
                    value: 'system',
                    width: '100',
                    sortable: true,
                },
                {
                    value: 'hidden',
                    width: '100',
                    sortable: true,
                },
                {
                    value: 'visible',
                    width: '100',
                    sortable: true,
                },
                {
                    value: 'audit_disabled',
                    width: '100',
                    sortable: true,
                },
                {
                    value: 'actions',
                    class: 'actions',
                    cellClass: 'actions',
                    sortable: false,
                    fields: null,
                    width: '150',
                    align: 'end',
                },
            ],
        };
    },
};
</script>
